import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';
import TicketDetails from '../TicketDetails/TicketDetails';
import {ETicketPage} from '../eTicketPage.type';
import CoverContent from '../CoverContent/CoverContent';
import TransactionCard from '../TransactionCard/TransactionCard';
import EntranceTicketStatus from '../EntranceTicketStatus/EntranceTicketStatus';
import TicketScanStatus from '../TicketScanStatus/TicketScanStatus';
import TransactionTop from '../TransactionCard/TransactionTop/TransactionTop';

export function useETicketPages() {
    const data = useSelector((s: RootState) => s.eTicket.data);

    const tickets = data?.tickets ?? [];
    const event = data?.event;
    const order = data?.order;

    const pages = useMemo((): ETicketPage[] => [
        {key: 'entrance', withLink: false, TopComp: EntranceTicketStatus, Comp: CoverContent},
        ...tickets.map((ticket, index) => ({
            key: `ticket-${ticket.tid}`,
            withLink: false,
            ...(event ? {
                TopComp: TicketScanStatus,
                topProps: {ticket},
                Comp: TicketDetails,
                props: {
                    ticket,
                    index,
                    total: tickets.length,
                    event,
                    order,
                },
            } : {}),
        })),
        {key: 'transaction', withLink: true, TopComp: TransactionTop, Comp: TransactionCard},
    ], [tickets, event, order]);

    return {pages};
}
